///////////////////
/// LAZY LOAD /////
///////////////////

$(document).on('lazyloaded', function(e) {
    console.log('** lazyloaded is fired', e.target);  
})

$(document).on('lazybeforeunveil', function(e) {
    
    // console.log('lazyloader baby!', e.target);

    var viewportWidth = $(window).innerWidth();
    // var bg = $(e.target).data('bg-mobile');
    var bg = $(e.target).data('bg-mobile');
    if (viewportWidth > 0) {
        bg = $(e.target).data('bg-mobile');
    }
    if (viewportWidth > 768) {
        bg = $(e.target).data('bg-tablet');
    }
    if (viewportWidth > 1023) {
        bg = $(e.target).data('bg-desktop');
    }
    if (viewportWidth > 1800) {
        bg = $(e.target).data('bg-super');
    } 

    if (bg) {
      // $(e.target).css('background-image', 'url(' + bg + ')');
      // TweenMax.set($($(e.target)), {backgroundImage:'url(' + bg + ')'});
      // Also if you're going to use the css wrapper it shoud be like this:
      // TweenMax.set($(e.target),   {opacity:0}); // delay: 1

      // var giveFadeInClass = function(){
        // $(e.target).addClass('fade-in');
      // }

      TweenMax.set($(e.target),   {css:{backgroundImage:'url(' + bg + ')'}, delay: 0.4}); // onComplete:giveFadeInClass

      // TweenMax.to($(e.target),    0.5,  {opacity:1, delay: 0.5}); // delay: 1
      
      // // in case of issues with opacity
      // var setOpacityTo1 = function(){
      //   console.log('%c setOpacityTo1 called', 'color: #bada55, background: #000');
      //   console.log($(e.target));
      //   TweenMax.set($(e.target),   {opacity:1});
      // }
      // TweenMax.delayedCall(6, setOpacityTo1);  

    }

}); 


///////////////////
/// UTILITIES /////
///////////////////

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
  var timeout;
  return function() {
    var context = this, args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

var scriptInit = function(){

    /////////////////////////////////////////////////////////////////////////////////////////////
    // Toggle on grid                                                                        / //
    /////////////////////////////////////////////////////////////////////////////////////////////

    window.onkeyup = function(e) {
       var key = e.keyCode ? e.keyCode : e.which;

       if (key == 71) {
          $('html').addClass('show-grid');
       } else if(key == 76) {
          $('html').addClass('show-lines');
       } else if (key == 27) {
           $('html').removeClass('show-grid');
           $('html').removeClass('show-lines');
       }
    }

    /////////////////////////////////////////////////////////////////////////////////////////////
    // Mobile height 100vh fix - https://css-tricks.com/the-trick-to-viewport-units-on-mobile/ //
    /////////////////////////////////////////////////////////////////////////////////////////////

    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    
    // We listen to the resize event
    window.addEventListener('resize', () => {
      // We execute the same script as before
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    });

    ///////////////////////////////
    // LAZY LOAD Sizes in RESIZE //
    ///////////////////////////////

    // var onResize = debounce(function() {

    //     console.log('resize triggered');
    //     // VARS
    //     var viewportWidth = $(window).innerWidth();

    //     /// LAZY SIZES FOR BACKGROUNDS....
    //     // console.log('onResize fired. viewportWidth is', viewportWidth);
    //     $.each($(".lazyloaded"), function(index, item) {
    //         var bg = $(item).data('bg-mobile');
    //         if (viewportWidth > 0) {
    //             bg = $(item).data('bg-mobile');
    //         }
    //         if (viewportWidth > 768) {
    //             bg = $(item).data('bg-tablet');
    //         }
    //         if (viewportWidth > 1023) {
    //             bg = $(item).data('bg-desktop');
    //         }
    //         if (viewportWidth > 1800) {
    //             bg = $(item).data('bg-super');
    //         }
    //         if (bg) {
    //             // console.log('lazyloader resize!', $(item), ' - onResize fired. viewportWidth is', viewportWidth);
    //             $(item).css('background-image', 'url(' + bg + ')');
    //         }
    //     });

    // }, 250);

    // window.addEventListener('resize', onResize);


    $("nav.off-canvas-menu .menu-item-has-children").click(function(event) {
      $(this).toggleClass('is-active');
    }); 

    
    // add class to hovered nav items with children
    $("#menu-top-menus-1 > .menu-item-has-children").hover(function(){
      $("#menu-top-menus-1 > .menu-item-has-children").removeClass("is-open");
      $(this).addClass("is-open");
    });

    $(".main-content").hover(function(){
      $("#menu-top-menus-1 > .menu-item-has-children").removeClass("is-open");
      $(this).addClass("is-open");
    });

    $(".nav--row").hover(function(){
      $("#menu-top-menus-1 > .menu-item-has-children").removeClass("is-open");
      $(this).addClass("is-open");
    });

    
    /*----------------------------------------------
      Add class to nav on scroll
      ------------------------------------------------*/
    $(window).scroll(function() {    
      var scroll = $(window).scrollTop();
      if (scroll >= 1) {
          $(".site-header").addClass("scrolled");
      }
      if (scroll <= 1) {
          $(".site-header").removeClass("scrolled");
      }
    });

    // content padding compensating for fixed nav
    //$(".single-post .site-main").css("margin-top", $(".nav").outerHeight());

    ///////////////////
    // MENU TOGGLE.  //
    ///////////////////

    // body.menu-is-open
    $("body .js-menu-toggle").click(function(event) {
      toggleClassMenu();
    });

    var toggleClassMenu = function() {

      $('.js-menu-toggle.hamburger').toggleClass('is-active');
      $('body').toggleClass('menu-is-open');

      var $labelCopy = $('js-hamburger--label').text();
      console.log( $labelCopy );
      if($labelCopy == 'Menu') {
        $('js-hamburger--label').text('Close');
      } else {
        $('js-hamburger--label').text('Menu');        
      }

      // console.log('%c menu toggled', 'background:#000; color:#fff');
      // $("body .off-canvas-menu").addClass("off-canvas-menu--animatable");   
      // if(!$("body .off-canvas-menu").hasClass("off-canvas-menu--visible")) {       
      //   $("body .off-canvas-menu").addClass("off-canvas-menu--visible");
      //   $('body').addClass('menu-open');
      //   $('html').addClass('menu-open');
      // } else {
      //   $("body .off-canvas-menu").removeClass('off-canvas-menu--visible');
      //   $('body .off-canvas-news-list').removeClass('off-canvas-news-list--visible');
      //   $('body').removeClass('menu-open');    
      //   $('body').removeClass('news-list-open');
        
      //   var removeClassFromHTML = function(){
      //     $('html').removeClass('menu-open');  
      //     $("body .off-canvas-menu").removeClass("off-canvas-menu--animatable");
      //   }

      //   TweenMax.delayedCall(0.2, removeClassFromHTML);   
      // }   

    }

    
    ///////////////////
    // SMOOTH SCROLL //
    ///////////////////

    // Select all links with hashes
    $('a[href*="#"]')
      // Remove links that don't actually link to anything
      .not('[href="#"]')
      .not('[href="#news"]') // added for news in overlay
      .not('[href="#0"]')
      .click(function(event) {
        // On-page links
        if (
          location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
          && 
          location.hostname == this.hostname
        ) {
          // Figure out element to scroll to
          var target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
          // Does a scroll target exist?
          if (target.length) {
            // Only prevent default if animation is actually gonna happen
            event.preventDefault();
            $('html, body').animate({
              scrollTop: target.offset().top
            }, 1000, function() {
              // Callback after animation
              // Must change focus!
              var $target = $(target);
              $target.focus();
              if ($target.is(":focus")) { // Checking if the target was focused
                return false;
              } else {
                $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
                $target.focus(); // Set focus again
              };
            });
          }
        }
      });


};

$(document).ready(function() {

  // ANIMS
  var wow = new WOW(
    {
      boxClass:     'wow',      // animated element css class (default is wow)
      animateClass: 'animated', // animation css class (default is animated)
      offset:       25,          // distance to the element when triggering the animation (default is 0)
      mobile:       true,       // trigger animations on mobile devices (default is true)
      live:         true,       // act on asynchronously loaded content (default is true)
      callback:     function(box) {
        // the callback is fired every time an animation is started
        // the argument that is passed in is the DOM node being animated
      },
      scrollContainer: null,    // optional scroll container selector, otherwise use window,
      resetAnimation: true,     // reset animation on end (default is true)
    }
  );
  wow.init();
  // document.getElementById('moar').onclick = function() {
  //   var section = document.createElement('section');
  //   section.className = 'section--purple wow fadeInDown';
  //   this.parentNode.insertBefore(section, this);
  // };

  ////////////////////
  /// SWUP ///////////
  ////////////////////

  // const pageTransitions = function() {
  // let pageTransitioning = false;
  // let animateInTimeline,
  //     animateOutTimeline,
  //     animateInNext;


  // // load scripts for replaced elements
  // document.addEventListener('swup:contentReplaced', event => {
  //   // swup.options.elements.forEach((selector) => {
  //       // load scripts for all elements with 'selector'
  //       // console.log( '%c contentReplaced ' + event.target.URL, 'background: #444; color: #888');
  //       // console.log($('body'));
  //       // scriptInit();
  //   // })
  //   // console.log(event);
  //   // console.log($('body'));
    
  //   setTimeout(function(){
  //     // console.log( '%c contentReplaced ' + event.target.URL, 'background: #444; color: #888');
  //     console.log($('body'));
  //     scriptInit();
  //   }, 1);
    
  // });

  // // document.addEventListener('swup:pageRetrievedFromCache', event => {
  // //   console.log( '%c pageRetrievedFromCache -> ' + event.target.URL, 'background: #222; color: #888');
  // //   scriptInit();
  // // });

  // let reverseLoad = () => {
  //     animateInNext && animateInNext();
  // }

  // let buildTimelineOut = (callback) => {
  //     let itemsToAnimate = $(".animate-out").toArray();
  //     itemsToAnimate.reverse();
  //     animateOutTimeline = new TimelineMax({ onComplete: callback });
  //     animateOutTimeline.to(itemsToAnimate, 0.3, { autoAlpha: 0 });
  // }

  // let buildTimelineIn = (callback) => {
  //     let itemsToAnimate = $(".animate-out").toArray();
  //     TweenMax.set(itemsToAnimate, { autoAlpha: 0 });
  //     animateInTimeline = new TimelineMax({ onComplete: callback, onReverseComplete: reverseLoad });
  //     animateInTimeline.to(itemsToAnimate, 0.3, { autoAlpha: 1 });
  // }

  // let options = {
  //   elements: ['#site-content', '#menu-main-menu'],
  //   // debugMode: true,
  //   preload: true,
  //   animateScroll: false,
  //   // pageClassPrefix: 'page-',
  //   animations: {
  //     // if link has data-swup-class="single-work"
  //     // '*>single-work': { 
  //     //   out: function(next) {
  //     //     console.log('%c ---->>>>>>> single work page baby', 'background: #bada55; color: #fff');
  //     //     // if (!pageTransitioning) {
  //     //     animateInNext = next;
  //     //     if (animateInTimeline && animateInTimeline.progress() < 1) {
  //     //       animateInTimeline.reverse();
  //     //     } else {
  //     //       if (!animateOutTimeline) {
  //     //         buildSingleWorkTimelineOut(next);
  //     //       }
  //     //       if (animateOutTimeline && !animateOutTimeline.isActive()) {
  //     //         buildSingleWorkTimelineOut(next);
  //     //       }
  //     //     }
  //     //   },
  //     //   in: function(next) {
  //     //     console.log(next);
  //     //     buildTimelineIn(next);
  //     //   }
  //     // },
  //     /// default transition
  //     '*': {
  //       out: function(next) {
  //         // if (!pageTransitioning) {
  //         animateInNext = next;
  //         if (animateInTimeline && animateInTimeline.progress() < 1) {
  //           animateInTimeline.reverse();
  //         } else {
  //           if (!animateOutTimeline) {
  //             buildTimelineOut(next);
  //           }
  //           if (animateOutTimeline && !animateOutTimeline.isActive()) {
  //             buildTimelineOut(next);
  //           }
  //         }
  //       },
  //       in: function(next) {
  //         console.log(next);
  //         buildTimelineIn(next);
  //       }
  //     }
  //   },
  //   LINK_SELECTOR: 'a[href^="/"]:not(.data-no-swup), a[href^="' + window.location.origin + '"]:not(.data-no-swup)'
  // }


  /*----------------------------------------------
  Wrap iframes in div .iframe-container to make them full width
  ------------------------------------------------*/
  // $('article iframe').wrap('<div class="iframe-container"></div>');

  /*----------------------------------------------
  Wrap social links in span
  ------------------------------------------------*/
  //$(".social a").wrapInner("<span></span>");

  /*----------------------------------------------
  Masonry
  ------------------------------------------------*/
  // $('.grid').masonry({
  //   // set itemSelector so .grid-sizer is not used in layout
  //   itemSelector: '.grid--item',
  //   // use element for option
  //   columnWidth: '.grid-sizer',
  //   gutter: '.gutter-sizer',
  //   percentPosition: true
  // });

  /*----------------------------------------------
  Magnific
  ------------------------------------------------*/
  // $('.popup-youtube').magnificPopup({
  //     disableOn: 700,
  //     type: 'iframe',
  //     mainClass: 'mfp-fade',
  //     removalDelay: 160,
  //     preloader: false,

  //     fixedContentPos: false
  //   });




  // let init = () => {
  //     var swup = new Swupjs(options);
  // }
  // return {
  //     init: init
  // }
  // }();

  ///////////////////
  // INIT SWUPS   ///
  ///////////////////
  // pageTransitions.init();


  ///////////////////
  // INIT SCRIPTS ///
  ///////////////////
  scriptInit();
  // alert('bosh');

});

// TABS START
/*
 *   This content is licensed according to the W3C Software License at
 *   https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 */
document.addEventListener('DOMContentLoaded', () => {
    var tablist = document.querySelectorAll('[role="tablist"]')[0];
    var tabs;
    var panels;
    var delay = 300;

    generateArrays();

    function generateArrays() {
        tabs = document.querySelectorAll('[role="tab"]');
        panels = document.querySelectorAll('[role="tabpanel"]');
    };

    // For easy reference
    var keys = {
        end: 35,
        home: 36,
        left: 37,
        up: 38,
        right: 39,
        down: 40,
        delete: 46
    };

    // Add or substract depending on key pressed
    var direction = {
        37: -1,
        38: -1,
        39: 1,
        40: 1
    };

    // Bind listeners
    for (let i = 0; i < tabs.length; ++i) {
        addListeners(i);
    };

    function addListeners(index) {
        tabs[index].addEventListener('click', clickEventListener);
        tabs[index].addEventListener('keydown', keydownEventListener);
        tabs[index].addEventListener('keyup', keyupEventListener);
        document.querySelector('.services__mobile-nav').addEventListener('change', dropDownChangeEventListener);
        // Build an array with all tabs (<button>s) in it
        tabs[index].index = index;
    };


    // When a tab is clicked, activateTab is fired to activate it
    function dropDownChangeEventListener(event) {
        event.preventDefault();

        let tabID = event.target.value,
            tab = document.getElementById(tabID);
        console.log(tabID, tab);
        activateTab(tab, false);
    };

    // When a tab is clicked, activateTab is fired to activate it
    function clickEventListener(event) {
        event.preventDefault();
        var tab = event.target;
        activateTab(tab, false);
    };

    // Handle keydown on tabs
    function keydownEventListener(event) {
        var key = event.keyCode;

        switch (key) {
            case keys.end:
                event.preventDefault();
                // Activate last tab
                activateTab(tabs[tabs.length - 1]);
                break;
            case keys.home:
                event.preventDefault();
                // Activate first tab
                activateTab(tabs[0]);
                break;

                // Up and down are in keydown
                // because we need to prevent page scroll >:)
            case keys.up:
            case keys.down:
                determineOrientation(event);
                break;
        };
    };

    // Handle keyup on tabs
    function keyupEventListener(event) {
        var key = event.keyCode;

        switch (key) {
            case keys.left:
            case keys.right:
                determineOrientation(event);
                break;
            case keys.delete:
                determineDeletable(event);
                break;
        };
    };

    // When a tablistâ€™s aria-orientation is set to vertical,
    // only up and down arrow should function.
    // In all other cases only left and right arrow function.
    function determineOrientation(event) {
        var key = event.keyCode;
        var vertical = tablist.getAttribute('aria-orientation') === 'vertical';
        var proceed = false;

        if (vertical) {
            if (key === keys.up || key === keys.down) {
                event.preventDefault();
                proceed = true;
            };
        } else {
            if (key === keys.left || key === keys.right) {
                proceed = true;
            };
        };

        if (proceed) {
            switchTabOnArrowPress(event);
        };
    };

    // Either focus the next, previous, first, or last tab
    // depening on key pressed
    function switchTabOnArrowPress(event) {
        var pressed = event.keyCode;

        for (let x = 0; x < tabs.length; x++) {
            tabs[x].addEventListener('focus', focusEventHandler);
        };

        if (direction[pressed]) {
            var target = event.target;
            if (target.index !== undefined) {
                if (tabs[target.index + direction[pressed]]) {
                    tabs[target.index + direction[pressed]].focus();
                } else if (pressed === keys.left || pressed === keys.up) {
                    focusLastTab();
                } else if (pressed === keys.right || pressed === keys.down) {
                    focusFirstTab();
                };
            };
        };
    };

    // Activates any given tab panel
    function activateTab(tab, setFocus) {
        setFocus = setFocus || true;
        // Deactivate all other tabs
        deactivateTabs(tab);
        // Remove tabindex attribute
        tab.removeAttribute('tabindex');

        // Set the tab as selected
        tab.setAttribute('aria-selected', 'true');

        // Get the value of aria-controls (which is an ID)
        var controls = tab.getAttribute('aria-controls');

        // Remove hidden attribute from tab panel to make it visible
        document.getElementById(controls).removeAttribute('hidden');

        // Set focus when required
        if (setFocus) {
            tab.focus();
        };
    };

    // Deactivate all tabs and tab panels
    function deactivateTabs(tab) {
        // get only the tabs within this section
        const tabsParent = tab.closest('.js-tabs-container');
        const theTabs = tabsParent.querySelectorAll('[role="tab"]');
        const thePanels = tabsParent.querySelectorAll('[role="tabpanel"]');

        for (let t = 0; t < theTabs.length; t++) {
            theTabs[t].setAttribute('tabindex', '-1');
            theTabs[t].setAttribute('aria-selected', 'false');
            theTabs[t].removeEventListener('focus', focusEventHandler);
        };

        for (let p = 0; p < thePanels.length; p++) {
            thePanels[p].setAttribute('hidden', 'hidden');
        };
    };

    // Make a guess
    function focusFirstTab() {
        tabs[0].focus();
    };

    // Make a guess
    function focusLastTab() {
        tabs[tabs.length - 1].focus();
    };

    // Detect if a tab is deletable
    function determineDeletable(event) {
        const target = event.target;

        if (target.getAttribute('data-deletable') !== null) {
            // Delete target tab
            deleteTab(event, target);

            // Update arrays related to tabs widget
            generateArrays();

            // Activate the closest tab to the one that was just deleted
            if (target.index - 1 < 0) {
                activateTab(tabs[0]);
            } else {
                activateTab(tabs[target.index - 1]);
            };
        };
    };

    // Deletes a tab and its panel
    function deleteTab(event) {
        var target = event.target;
        var panel = document.getElementById(target.getAttribute('aria-controls'));

        target.parentElement.removeChild(target);
        panel.parentElement.removeChild(panel);
    };

    //
    function focusEventHandler(event) {
        var target = event.target;

        setTimeout(checkTabFocus, delay, target);
    };

    // Only activate tab on focus if it still has focus after the delay
    function checkTabFocus(target) {
        const focused = document.activeElement;

        if (target === focused) {
            activateTab(target, false);
        };
    };
});
// TABS END